import { Navigate } from "react-router-dom";
import { authState } from "../state/atoms";
import { useRecoilState } from "recoil";

const ProtectedRoute = ({ children }: any) => {
  const [auth] = useRecoilState(authState);
  return auth ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
